<div>
  @if (busy) {
    <div class="overlay">
      <div class="center">
        <mat-spinner>
        </mat-spinner>
      </div>
    </div>
  }
  <div class="dialog-close" >
    <button mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content class="flex-col w-100">
    <div class="flex-col justify-center items-center w-100 mt-0">
      <span class="amount">Authorize {{amountToAuthorize | currency : 'USD' : 'symbol' : '1.2-2'}}</span>
      @if (plaidError) {
        <div class="w-100 my-2 plaidError">
          {{plaidError}}
        </div>
      }
      @if (plaidMessage) {
        <div class="w-100 my-2 plaidMessage">
          {{plaidMessage}}
        </div>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions >
    <div class="w-100 mt-0 ml-4 justify-center items-center">
      <span> By selecting 'Authorize now' you agree your card being authorized for the stated amount. We will not capture the charge at this stage.</span>
    </div>
  </mat-dialog-actions>
</div>


